import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface CrmUser {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  phone: string | null;
  picture: string | null;
  alreadyProvisioned: boolean;
}

export class GetCrmUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'get-crm-users-failure') {
    super(message, code);
  }
}

async function getCrmUsers(companyId: string, authentication: Authentication): Promise<CrmUser[]> {
  try {
    const response = await HttpClient.get(
      `/integrations/companies/${companyId}/users`,
      authentication.token
    );
    return response?.data ?? [];
  } catch (e) {
    throw new GetCrmUsersFailure((e as Error).message);
  }
}

export default getCrmUsers;
